import UserProfile from './../../common/user/profile';

export default function (data, parent) {
  UserProfile.init();

  let self = this;
  self.$el = $('#account');
  self.profile = ko.observable();

  let dataBind = Object.assign({});

  self.$el.data().bind.split(', ')
    .map(str =>
      [
        str.split(': ')[0],
        str.split(': ')[1]
      ]
    ).forEach(keyValueStr =>
      dataBind[ keyValueStr[0] ] = keyValueStr[1]
    );

  const currentPasswordRequired = dataBind.currentPasswordRequired == 'true';

  self.first_name = ko.observable(data.first_name).extend({required: true});
  self.last_name = ko.observable(data.last_name).extend({required: true});
  self.email = ko.observable().extend({required: true, email: true});
  self.current_password = ko.observable().extend({required: currentPasswordRequired});
  self.password = ko.observable().extend({required: true, minLength: 8});
  self.password_confirmation = ko.observable().extend({required: true, equal: {params: self.password, message: 'Passwords must match'}});
  self.forgot_password_triggered = ko.observable(false);

  self.bindData = function(data) {
    let mapped_profile = ko.mapping.fromJS(data, {ignore: ['first_name','last_name','current_password','password','password_confirmation']});
    self.profile(mapped_profile);
  };

  self.save = function(data) {
    let request = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: Kadenze.Routes.users_path(),
      data: data,
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(response) {
      new Kadenze.Notice.success({ message: Kadenze.I18n.t('dict.save_success') });
    });

    request.fail(function(xhr, status, msg) {
      Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
    });

    return request;
  };

  self.updateBasicInfo = function() {
    self.client_errors = ko.validation.group([self.first_name, self.last_name], { deep: true });
    if (self.client_errors().length === 0) {
      let data = {user: {}};
      data.user.first_name = self.first_name();
      data.user.last_name = self.last_name();
      self.save(data).done(function () {
        parent.profile().first_name(self.first_name());
        parent.profile().last_name(self.last_name());
      });
    } else {
      self.client_errors.showAllMessages();
    }
  };

  self.updatePassword = function() {
    self.client_errors = ko.validation.group([self.current_password, self.password, self.password_confirmation], { deep: true });
    if (self.client_errors().length === 0) {
      let data = {user: {}};
      data.user.current_password = self.current_password();
      data.user.password = self.password();
      data.user.password_confirmation = self.password_confirmation();
      self.save(data);
    } else {
      self.client_errors.showAllMessages();
    }
  };

  self.forgotPassword = function () {
    let request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.forgot_password_path(),
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(response) {
      self.forgot_password_triggered(true);
      new Kadenze.Notice.success({ message: Kadenze.I18n.t('notice.sign_up.password_reset_instructions') });
    });

    request.fail(function(xhr, status, msg) {
      Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
    });
  };

  self.updateEmail = function() {
    self.client_errors = ko.validation.group([self.email], { deep: true });
    if (self.client_errors().length === 0) {
      let data = {user: {}};
      data.user.email = self.email();
      self.save(data);
    } else {
      self.client_errors.showAllMessages();
    }
  };

  const __construct = function(that) {
    console.log('constructor called for AccountVM');
    that.bindData(data);
  }(this);
}

